document.addEventListener('DOMContentLoaded', function () {
  const MEDIA_SELECTOR = '.product__media-wrapper';
  const INFO_SELECTOR = '.product__info-container';
  const MIN_WIDTH = 750;

  const media = document.querySelector(MEDIA_SELECTOR);
  const info = document.querySelector(INFO_SELECTOR);
  if (!media || !info) return;

  function ancestorHasTransform(el) {
    let node = el.parentElement;
    while (node && node !== document.body) {
      const cs = getComputedStyle(node);
      if ((cs.transform && cs.transform !== 'none') || (cs.perspective && cs.perspective !== 'none') || (cs.filter && cs.filter !== 'none')) return true;
      node = node.parentElement;
    }
    return false;
  }

  function needsFallback() {
    const supportsSticky = (typeof CSS !== 'undefined' && CSS.supports && CSS.supports('position', 'sticky'));
    return !supportsSticky || ancestorHasTransform(media);
  }

  if (window.matchMedia(`(min-width: ${MIN_WIDTH}px)`).matches && needsFallback()) {
    // Lightweight JS fallback that toggles fixed positioning when appropriate
    let ticking = false;
    const topOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--pdp-media-top')) || 48;
    let placeholder = null;

    function applyStatic() {
      media.style.position = '';
      media.style.top = '';
      media.style.width = '';
      media.style.zIndex = '';
      if (placeholder && placeholder.parentElement) {
        placeholder.parentElement.removeChild(placeholder);
        placeholder = null;
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const infoRect = info.getBoundingClientRect();
        const mediaRect = media.getBoundingClientRect();

        // If info's top has scrolled past the topOffset and info still extends beyond the media height,
        // fix the media to the viewport. Otherwise release it.
        if (infoRect.top < topOffset && (infoRect.bottom > mediaRect.height + topOffset)) {
          // Stick the media as fixed to emulate CSS sticky
          if (getComputedStyle(media).position !== 'fixed') {
            // Insert placeholder to preserve layout and avoid vertical jumps when we take the media out of flow
            if (!placeholder) {
              placeholder = document.createElement('div');
              placeholder.style.width = mediaRect.width + 'px';
              placeholder.style.height = mediaRect.height + 'px';
              media.parentElement.insertBefore(placeholder, media);
            } else {
              placeholder.style.height = mediaRect.height + 'px';
              placeholder.style.width = mediaRect.width + 'px';
            }

            media.style.position = 'fixed';
            media.style.top = topOffset + 'px';
            media.style.width = mediaRect.width + 'px';
            media.style.zIndex = 2;
          }
        } else {
          applyStatic();
        }

        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
      applyStatic();
      onScroll();
    }, { passive: true });

    // Recalculate after any Shopify section loads / DOM changes
    document.addEventListener('shopify:section:load', () => {
      applyStatic();
      onScroll();
    });

    // Initial positioning
    onScroll();
  }
});
